export const getUserInfoEndpoint = () => '/user_info' as const
